import React from "react";

import styles from "./placeholder.module.css";

export default function Placeholder({ text, icon, phone, email }) {
  const styledIcon = React.cloneElement(icon, { className: styles.icon });

  return (
    <div className={styles.container}>
      {styledIcon}
      <div>{text}</div>
      {(email || phone) && (
        <div>
          Please contact the property: <span className={styles.textColor}>{email && email}</span> &{" "}
          <span className={styles.textColor}>{phone && phone} </span>
        </div>
      )}
    </div>
  );
}
